/*eslint-disable react/jsx-key */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

// components
import LoadingIndicator from '../../../../../components/LoadingIndicator';
import EmptyState from '../../../../../components/EmptyState';
import AlertMessage from '../../../../../components/AlertMessage';
import InfoTitle from '../components/InfoTitle';
import Icon from '../../../../../components/Icon';

// redux
import { getActiveNfOccurrences } from '../../../../../redux/tracking';
import { getActiveNfOccurrencesUi } from '../../../../../redux/selectors';
import { hasRole } from '../../../../../utils/hasRole.ts';

// css
import './styles.css';
import {
  TooltipBox,
  ToolTipBoxText,
  TooltipCard,
  TooltipText,
} from '../../../../../components/Tooltip';
import AllowanceRelease from '../components/AllowanceRelease';
import { luftGet, luftPost } from '../../../../../shared/http';
import { PERFORMANCE_ENUM } from '../../../../../enums/performance-enum';
import Button from '../../../../../components/Button';
import TrackingDetailsOcurrenceForm from './TrackingDetailsOcurrenceForm';
import {
  DetailsOccurrences,
  FormContainer,
  Line,
  LineTumbWrapper,
  OccurenceTag,
  OccurrenceContainer,
  OccurrenceDate,
  OccurrenceInfo,
  OccurrenceText,
  OccurrenceTitle,
  OccurrenceTitleWrapper,
  OccurrenceWrapper,
  RegisteredDate,
  TagText,
  Tumb,
  UserName,
} from './styles';
import { rolesList } from '../../../../../redux/auth';
import { getSessionUser } from '../../../../../shared/http/auth';
class Occurrences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allowanceList: {
        isFetching: false,
        data: [],
      },
      showForm: false,
      typeList: {
        isFetching: false,
        data: [],
      },
    };
  }

  componentDidMount() {
    this._getActiveNfOccurrences();
    this._requestAllowanceList();
  }

  _getActiveNfOccurrences = () => {
    const { dispatch, nfData } = this.props;

    dispatch(getActiveNfOccurrences(nfData.tms.tmsId, nfData.nf));
  };

  _getUserNameBranch = userName => {
    const arrayOfStrings = userName.split('-');
    return {
      name: arrayOfStrings[0],
      branch: arrayOfStrings[1],
    };
  };

  _handleSubmitAllowance = async isAllowance => {
    const { nfData } = this.props;

    const { id } = nfData;

    try {
      this.setState(prevState => ({
        allowanceList: {
          ...prevState.allowanceList,
          isFetching: true,
        },
      }));
      await luftPost('/InvoiceAllowance', {
        isAllowance,
        invoiceId: id,
      });

      this.setState(
        prevState => ({
          allowanceList: {
            ...prevState.allowanceList,
            isFetching: false,
          },
        }),
        () => this._requestAllowanceList(),
      );
    } catch (error) {
      console.log({ error });
    }
  };

  _requestAllowanceList = async () => {
    const { nfData } = this.props;

    const { id } = nfData;

    try {
      this.setState(prevState => ({
        ...prevState,
        allowanceList: {
          ...prevState.allowanceList,
          isFetching: true,
        },
        typeList: {
          ...prevState.typeList,
          isFetching: true,
        },
      }));

      const [allowanceList, typeList] = await Promise.all([
        luftGet('/InvoiceAllowance/GetByInvoiceId', {
          invoiceId: id,
        }),
        luftGet('/Invoice/GetOccurrenceList'),
      ]);

      this.setState(prevState => ({
        ...prevState,
        allowanceList: {
          ...prevState.allowanceList,
          isFetching: false,
          data: allowanceList.data,
        },
        typeList: {
          ...prevState.typeList,
          isFetching: false,
          data: typeList.data,
        },
      }));
    } catch (error) {
      this.setState(prevState => ({
        ...prevState,
        allowanceList: {
          ...prevState.allowanceList,
          isFetching: false,
        },
        typeList: {
          ...prevState.typeList,
          isFetching: false,
        },
      }));
    }
  };

  _toggleForm = () => {
    this.setState(prevState => ({
      ...prevState,
      showForm: !prevState.showForm,
    }));
  };

  render() {
    const { occurrences, ui, nfData } = this.props;
    const { performance } = nfData;

    const { allowanceList } = this.state;

    const user = getSessionUser();
    const isUserHasPermissionToCreateOccurrence = hasRole(
      rolesList.ADMIN_CUSTOMER,
      user.roles,
    );

    return (
      <div className="TrackingDetailsOccurrences">
        <DetailsOccurrences>
          <InfoTitle>Registros de ocorrências</InfoTitle>
          <OccurrenceContainer>
            {/* ======================= */}
            {/* ==== LOADING STATE ==== */}
            {/* ======================= */}
            {ui.isFetching && (
              <LoadingIndicator theme="dark" text="Carregando..." />
            )}

            {/* ===================== */}
            {/* ==== EMPTY STATE ==== */}
            {/* ===================== */}
            {!ui.isFetching && occurrences.length === 0 && !ui.error && (
              <EmptyState message="Nenhuma ocorrência encontrada." />
            )}

            {/* ===================== */}
            {/* ==== ERROR STATE ==== */}
            {/* ===================== */}
            {!ui.isFetching && ui.error && (
              <AlertMessage
                message={`Ocorreu um erro ao carregar as ocorrências. ${ui.error}`}
                actionText="Tentar Novamente"
                onRetry={this._getActiveNfOccurrences}
                error
              />
            )}

            {/* ======================= */}
            {/* ==== NORMAL STATE ===== */}
            {/* ======================= */}
            {!ui.isFetching &&
              !ui.error &&
              occurrences.length > 0 &&
              occurrences.map(occurrence => (
                <OccurrenceWrapper>
                  <LineTumbWrapper>
                    <Tumb />
                    <Line />
                  </LineTumbWrapper>
                  <OccurrenceInfo
                    key={`${occurrence.type}-${occurrence.username}-${occurrence.occurrenceDate}`}
                  >
                    <OccurrenceTitleWrapper>
                      <OccurrenceTitle>{occurrence.type}</OccurrenceTitle>
                      {occurrence.justified ? (
                        <TooltipCard width={271}>
                          <TooltipText>
                            <OccurenceTag backgroundColor="#FF9800">
                              <Icon name="error2" />
                              <TagText>Abono</TagText>
                            </OccurenceTag>
                          </TooltipText>
                          <TooltipBox>
                            <ToolTipBoxText>
                              Ocorrência sujeita à validação de abono de
                              performance.
                            </ToolTipBoxText>
                          </TooltipBox>
                        </TooltipCard>
                      ) : null}
                      {occurrence.trip ? (
                        <OccurenceTag backgroundColor="#1077B9">
                          <Icon name="truck" />
                          <TagText>Viagem</TagText>
                        </OccurenceTag>
                      ) : null}
                    </OccurrenceTitleWrapper>
                    <OccurrenceDate>
                      {moment(occurrence.occurrenceDate).format(
                        'DD/MM/YYYY • HH:mm:ss',
                      )}
                    </OccurrenceDate>
                    <OccurrenceText>
                      {occurrence.occurrenceText
                        ? `Ocorrência: ${occurrence.occurrenceText}`
                        : ''}
                    </OccurrenceText>
                    <RegisteredDate>
                      Registrado em{' '}
                      {moment(occurrence.registerDate).format(
                        'DD/MM/YYYY • HH:mm:ss',
                      )}
                    </RegisteredDate>
                    {occurrence.username && (
                      <UserName>
                        {this._getUserNameBranch(occurrence.username).name}{' '}
                        {this._getUserNameBranch(occurrence.username).branch
                          ? ' / '
                          : null}{' '}
                        {
                          <strong>
                            {
                              this._getUserNameBranch(occurrence.username)
                                .branch
                            }
                          </strong>
                        }
                      </UserName>
                    )}
                  </OccurrenceInfo>
                </OccurrenceWrapper>
              ))}
          </OccurrenceContainer>
        </DetailsOccurrences>

        {performance === PERFORMANCE_ENUM.ON_TIME_WITH_JUSTIFICATION ||
        performance === PERFORMANCE_ENUM.LATE_RISK_WITH_JUSTIFICATION ||
        performance === PERFORMANCE_ENUM.LATED_WITH_JUSTIFICATION ? (
          <AllowanceRelease
            handleSubmit={this._handleSubmitAllowance}
            allowanceList={allowanceList}
          />
        ) : null}

        {isUserHasPermissionToCreateOccurrence && (
          <FormContainer>
            {this.state.showForm ? (
              <TrackingDetailsOcurrenceForm
                toggleForm={this._toggleForm}
                nfData={this.props.nfData}
                typeList={this.state.typeList}
                onSuccess={() => {
                  this._toggleForm();
                  this._getActiveNfOccurrences();
                }}
              />
            ) : (
              <Button
                type="button"
                text="NOVA OCORRÊNCIA"
                skin="primary"
                icon="plus"
                className="TrackingDetailsOccurrences__new-occurrence__creation-button"
                onClick={this._toggleForm}
              />
            )}
          </FormContainer>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ui: getActiveNfOccurrencesUi(state),
    occurrences: state.tracking.activeNfOccurrences.data,
  };
}

export default connect(mapStateToProps)(Occurrences);
